module.exports = __webpack_public_path__ + "img/86.4caf2b35.png";